class focusButton {
    constructor($timeout) {

        this.link = (scope, elem, attrs) => {

            $timeout(() => {
                elem.parent().parent().find('button')[0].focus();
            }, 200);
        }
    }

    /**
     * Factory
     * @return {Object}
     */
    static directiveFactory($timeout) {
        focusButton.instance = new focusButton($timeout);
        return focusButton.instance;
    }
}

export default focusButton;



/** WEBPACK FOOTER **
 ** ./src/app/directives/common/focusButton.js
 **/